import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import api, { formatStampUK } from "@/lib/api";

const MESSAGES = {
  failed: "The last database backup FAILED.",
  overdue: "No successful database backup in the last 26 hours.",
  never: "No successful database backup exists yet.",
  tool_missing: "The backup tool cannot run on this server.",
};

export const BackupAlert = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [st, setSt] = useState(null);
  const allowed = ["owner", "accountant"].includes(user?.role);

  useEffect(() => {
    if (!allowed) {
      return;
    }
    api.get("/admin/backup-status").then((r) => setSt(r.data)).catch(() => setSt({ state: "unknown" }));
  }, [allowed]);

  if (!allowed || !st || st.ok) return null;
  return (
    <button type="button" onClick={() => navigate("/reports")} data-testid="backup-alert-banner"
      className="w-full flex items-start gap-2 bg-red-600 text-white text-left text-sm px-4 py-3 min-h-[44px]">
      <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
      <span>
        <strong>Backup problem.</strong> {MESSAGES[st.state] || "Backup status could not be checked."}{" "}
        {st.last_success_at ? `Last good backup ${formatStampUK(st.last_success_at)}.` : ""} Tap to open Reports &amp; Backups.
      </span>
    </button>
  );
};
